import { render, staticRenderFns } from "./WidgetChart1.vue?vue&type=template&id=438bf9f0&scoped=true"
import script from "./WidgetChart1.vue?vue&type=script&lang=js"
export * from "./WidgetChart1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438bf9f0",
  null
  
)

export default component.exports